import { Body16, H2, List, Modal } from "@/components";
import useJob from "@/modules/hooks/useJob";
import { formatDate } from "@/utils";
import polyglot from "@/utils/polyglot";

const RecurringJobsModal = ({ isOpen, onClose }) => {
  const { data } = useJob();

  return (
    <Modal.XSmall isOpen={isOpen} onClose={onClose}>
      <Modal.Item.Header isOpen={isOpen} onClose={onClose}>
        <H2>{polyglot.t("jobs.active_jobs")}</H2>
      </Modal.Item.Header>
      <List.Group>
        {data.recurring_jobs.map((job) => (
          <List.Item key={job.id} href={job.url} chevron withGutters>
            <Body16>{formatDate(job.date, "ddd DD MMMM")}</Body16>
          </List.Item>
        ))}
      </List.Group>
    </Modal.XSmall>
  );
};

export default RecurringJobsModal;
